export function onYouTubeIframeAPIReady(videoContainers) {
  window.videoPlayerOZ = [];
  window.videoPlayerOZReady = false;
  window.resizedVideoIframe = false;

  for (let index = 0; index < videoContainers.length; index++) {
    const videoContainer = videoContainers[index];
    const videoPlaceholder = videoContainer.getElementsByClassName('video')[0];
    const videoCover = videoContainer.getElementsByClassName('video-cover')[0];
    const videoUrl = videoContainer.getAttribute('data-video-url');
    const videoID = YouTubeTPlayerMethods.getVideoID(videoUrl);

    if (!videoID) continue;

    // eslint-disable-next-line no-undef
    window.videoPlayerOZ[index] = new YT.Player(videoPlaceholder, {
      width: '100%',
      height: 340,
      videoId: videoID,
      playerVars: {
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
        disablekb: 1,
        fs: 0,
        autohide: 1
      },
      events: {
        onReady: YouTubeTPlayerMethods.onPlayerReady.bind(this, videoContainers),
        onStateChange: YouTubeTPlayerMethods.onPlayerStateChange.bind(this, videoContainer, videoContainers),
        onError: YouTubeTPlayerMethods.onPlayerError
      }
    });

    if (videoCover) {
      videoCover.addEventListener('click', (e) => {
        if (videoContainer.classList.contains('stop')) {
          window.videoPlayerOZ[index].playVideo();
          videoContainer.classList.remove('stop');
        } else {
          window.videoPlayerOZ[index].stopVideo();
          videoContainer.classList.add('stop');
        }
      });

      YouTubeTPlayerMethods.setVideoCoverImage(videoCover, videoID);
    }
  }
}

export const YouTubeTPlayerMethods = {
  videoCoverSrc: 'http://img.youtube.com/vi/',
  videoCoverImageIndex: '0.jpg',
  currentWindowWidth: window.innerWidth,
  onPlayerReady: (videoContainers, e) => {
    window.videoPlayerOZReady = true;

    if (!window.resizedVideoIframe) {
      YouTubeTPlayerMethods.resizeIframe(videoContainers);
    }
    window.resizedVideoIframe = true;
  },

  onPlayerStateChange: (videoContainer, videoContainers, e) => {
    const videoState = e.data;

    // playing
    if (videoState === 1) {
      videoContainer.classList.remove('stop');
      videoContainer.classList.add('playing');

      YouTubeTPlayerMethods.stopPlayingVideos(videoContainers, videoContainer);
    }

    // unstarted, paused, ended
    if (videoState === -1 || videoState === 2 || videoState === 0) {
      videoContainer.classList.remove('playing');
      videoContainer.classList.add('stop');
    }

    if (window.innerWidth !== YouTubeTPlayerMethods.currentWindowWidth) {
      YouTubeTPlayerMethods.currentWindowWidth = window.innerWidth;
      YouTubeTPlayerMethods.resizeIframe(videoContainers);
    }
  },

  onPlayerError: (e) => {
    // eslint-disable-next-line no-console
    console.error('ERRORE', e);
  },

  getVideoID: (videoUrl) => {
    // eslint-disable-next-line no-useless-escape
    const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
    const match = videoUrl.match(regExp);
    return match && match[1].length === 11 ? match[1] : null;
  },

  stopPlayingVideos: (videoContainers, currentPlayingVideo) => {
    const videoContainersTotal = videoContainers.length;
    if (!videoContainersTotal) return;

    for (let index = 0; index < videoContainersTotal; index++) {
      const videoContainer = videoContainers[index];
      if (currentPlayingVideo.id !== videoContainer.id && videoContainer.classList.contains('playing')) {
        window.videoPlayerOZ[index].stopVideo();
        videoContainer.classList.remove('playing');
        videoContainer.classList.add('stop');
      }
    }
  },

  setIframeSize: (videoCover, iframe) => {
    const size = YouTubeTPlayerMethods.getIframeSize(videoCover, iframe);

    iframe.style.width = `${size.w}px`;
    iframe.style.height = `${size.h}px`;
  },

  getIframeSize: (videoCover) => {
    const videoCoverRect = videoCover.getBoundingClientRect();
    // video size: 16:9
    const h = videoCoverRect.width / 1.8;
    const w = videoCoverRect.width;

    return { h, w };
  },

  setVideoCoverImage: (cover, videoID) => {
    const imgElement = document.createElement('img');
    imgElement.src = `${YouTubeTPlayerMethods.videoCoverSrc}${videoID}/${YouTubeTPlayerMethods.videoCoverImageIndex}`;

    cover.append(imgElement);
  },

  resizeIframe: (videoContainers) => {
    if (!videoContainers) return;

    const slideTotal = videoContainers.length;

    for (let index = 0; index < slideTotal; index++) {
      const slide = videoContainers[index];
      const iframe = slide.getElementsByTagName('iframe')[0];
      YouTubeTPlayerMethods.setIframeSize(slide, iframe);
    }
  }
};
